module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row4_rules.31bae31d.png";